import { type Feature, hasFeature } from "../session/features.ts";
import type { Role } from "../session/roles.ts";

export function withFeature(feature: Feature, roles?: readonly Role[]): Role[] {
    const featureRole = hasFeature(feature);

    if (!roles) {
        return [featureRole];
    }

    return roles.map(role => (session => role(session) && featureRole(session)) satisfies Role);
}
